import { XState } from '@frontend/duck-tape';

export type AccountDetailsModalContext = {
  inviteToRemove: { id: string; name: string };
  memberToRemove: { id: string; name: string };
};

export type AccountDetailsModalEvents =
  | { inviteId: string; inviteName: string; type: 'showRemoveInvite' }
  | { memberId: string; memberName: string; type: 'showRemoveMember' }
  | { type: 'back' }
  | { type: 'showBuyCredits' }
  | { type: 'showCreditHistory' }
  | { type: 'showInviteMember' };

export const accountDetailsModalMachine = XState.setup({
  types: {
    context: {} as AccountDetailsModalContext,
    events: {} as AccountDetailsModalEvents,
  },
}).createMachine({
  context: {
    inviteToRemove: { id: '', name: '' },
    memberToRemove: { id: '', name: '' },
  },
  id: 'accountDetailsModal',
  initial: 'accountDetails',
  states: {
    accountDetails: {
      on: {
        showBuyCredits: 'buyCredits',
        showCreditHistory: 'creditHistory',
        showInviteMember: 'inviteMember',
        showRemoveInvite: {
          actions: XState.assign({
            inviteToRemove: ({ event }) => ({
              id: event.inviteId,
              name: event.inviteName,
            }),
          }),
          target: 'removeInviteConfirmation',
        },
        showRemoveMember: {
          actions: XState.assign({
            memberToRemove: ({ event }) => ({
              id: event.memberId,
              name: event.memberName,
            }),
          }),
          target: 'removeMemberConfirmation',
        },
      },
    },
    buyCredits: {
      on: {
        back: 'accountDetails',
      },
    },
    creditHistory: {
      on: {
        back: 'accountDetails',
      },
    },
    inviteMember: {
      on: {
        back: 'accountDetails',
      },
    },
    removeInviteConfirmation: {
      on: {
        back: 'accountDetails',
      },
    },
    removeMemberConfirmation: {
      on: {
        back: 'accountDetails',
      },
    },
  },
});
